// extracted by mini-css-extract-plugin
module.exports = {"title":"MenuTitle_title__elgD6"};